import { render, staticRenderFns } from "./ReactivationWaitlistCard.vue?vue&type=template&id=76da46f6&"
import script from "./ReactivationWaitlistCard.vue?vue&type=script&lang=ts&"
export * from "./ReactivationWaitlistCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports